import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { Title } from "../../../../components/Title";
import {
  RiArrowRightFill,
  RiDeleteBin2Line,
  RiSettings3Line,
} from "react-icons/ri";

import { AllLoading } from "../../../../components/allLoading";
import { lmWord, typeCaregoryQuestion } from "../../../../utils/utils";
import { useRef, useState } from "react";
import { api } from "../../../../service/api";
import { useListAllCategories } from "../hooks/useListAllCategories";

export function ListCategories() {
  const toast = useToast();

  const { dataList, loading, refetch } = useListAllCategories();
  const [idQuestion, setIdQuestion] = useState("");
  const [loadingDelete, setLoadingDelete] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef<any>();

  async function deleteQuestion(id: string) {
    try {
      setLoadingDelete(true);
      await api.delete(`category/question/delete/${id}`);
      toast({
        position: "top-right",
        title: "Categoria",
        description: "Categoria removido com sucesso.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      setIdQuestion("");
      onClose();
      refetch();
    } catch (error) {
      toast({
        position: "top-right",
        title: "Questão",
        description: "Não foi possível remover categoria.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } finally {
      setLoadingDelete(false);
    }
  }

  return (
    <Flex w="100%" flexDirection="column" marginBottom="100px">
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Excluir cateogria</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>Deseja excluir categoria?</AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Não
            </Button>
            <Button
              isLoading={loadingDelete}
              colorScheme="red"
              ml={3}
              onClick={() => {
                deleteQuestion(idQuestion);
              }}
            >
              Sim
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <Flex style={{ marginTop: 48, flexDirection: "column" }}>
        <Title title="Configurações" />

        <Button
          as="a"
          bg="green.500"
          color="white"
          style={{
            borderRadius: 53,
            height: 44,
            fontSize: 16,
            fontWeight: 600,
          }}
          width={["100%", "100%", "250px"]}
          _hover={{
            bg: "green.500",
          }}
          mt="6"
          size="lg"
          rightIcon={
            <Icon fontSize="20px" as={RiArrowRightFill} color="#fff" />
          }
          href="/nova/configuracoes"
        >
          Nova configuração
        </Button>

        {loading && <AllLoading />}

        {!loading && dataList.length > 0 && (
          <Flex
            style={{
              marginTop: 60,
              flexDirection: "column",
            }}
          >
            <TableContainer
              width={["350px", "350px", "100%"]}
              overflowX="scroll"
            >
              <Table>
                <Thead>
                  <Tr>
                    <Th style={{ fontSize: "12px" }}>Tipo</Th>
                    <Th style={{ fontSize: "12px" }}>Sub tipo</Th>
                    <Th style={{ fontSize: "12px" }}>Nome</Th>
                    <Th style={{ fontSize: "12px" }}>Ações</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {dataList.map((item, index) => {
                    return (
                      <Tr
                        key={index}
                        borderBottomWidth={1.5}
                        borderBottomColor="#069"
                      >
                        <Td style={{ fontSize: "12px" }}>
                          {typeCaregoryQuestion(item.type)}
                        </Td>
                        <Td style={{ fontSize: "12px" }}>
                          {lmWord(item.sub_category ?? "", 30)}
                        </Td>
                        <Td style={{ fontSize: "12px" }}>
                          {lmWord(item.name ?? "", 100)}
                        </Td>

                        <Td>
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={
                                <Icon
                                  fontSize="16px"
                                  as={RiSettings3Line}
                                  color="#0577BE"
                                />
                              }
                              variant="outline"
                            />
                            <MenuList>
                              <MenuItem
                                onClick={() => {
                                  setIdQuestion(item.id);
                                  onOpen();
                                }}
                                icon={
                                  <Icon
                                    fontSize="16px"
                                    as={RiDeleteBin2Line}
                                    color="#0577BE"
                                  />
                                }
                              >
                                Excluir
                              </MenuItem>
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}
